import React from 'react';
import { User } from '../../types';
import { Edit2, Trash2 } from 'lucide-react';
import { Button } from '../ui/Button';
import { getDepartmentLabel } from '../../utils/departments';
import { motion } from 'framer-motion';

interface UserListProps {
  users: User[];
  onEdit: (user: User) => void;
  onDelete: (userId: string) => void;
}

export const UserList: React.FC<UserListProps> = ({ users, onEdit, onDelete }) => {
  return (
    <div className="space-y-4">
      {users.map((user, index) => (
        <motion.div
          key={user.id}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          className="bg-white rounded-lg border border-gray-200 p-4 hover:shadow-md transition-shadow"
        >
          <div className="flex items-center justify-between gap-4">
            <div className="flex items-center gap-4 min-w-0">
              <img
                src={user.avatar}
                alt={user.name}
                className="w-12 h-12 rounded-full shrink-0"
              />
              <div className="min-w-0">
                <h3 className="font-medium text-gray-900">{user.name}</h3>
                <div className="text-sm text-gray-500 space-y-1">
                  <p className="hidden sm:block max-w-[200px] truncate">{user.email}</p>
                  <div className="flex items-center gap-2 flex-wrap">
                    <span className="px-2 py-0.5 bg-emerald-100 text-emerald-700 rounded-full text-xs whitespace-nowrap">
                      {user.role}
                    </span>
                    <span className="px-2 py-0.5 bg-blue-100 text-blue-700 rounded-full text-xs whitespace-nowrap">
                      {getDepartmentLabel(user.department)}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="flex items-center gap-2 shrink-0">
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onEdit(user)}
                icon={<Edit2 className="w-4 h-4" />}
                className="sm:flex hidden"
              >
                Edit
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onEdit(user)}
                icon={<Edit2 className="w-4 h-4" />}
                className="sm:hidden"
                aria-label="Edit user"
              />
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onDelete(user.id)}
                icon={<Trash2 className="w-4 h-4" />}
                className="text-red-600 hover:text-red-700 sm:flex hidden"
              >
                Delete
              </Button>
              <Button
                variant="ghost"
                size="sm"
                onClick={() => onDelete(user.id)}
                icon={<Trash2 className="w-4 h-4" />}
                className="text-red-600 hover:text-red-700 sm:hidden"
                aria-label="Delete user"
              />
            </div>
          </div>
        </motion.div>
      ))}
    </div>
  );
};